import { Create } from "react-admin";
import { useAdmin } from "../../hooks/admin";
import { SupplierForm } from "./_form";
import { uploadFile } from "@/utils/file-upload";
import { buckets } from "@/core/buckets";
import { nanoid } from "nanoid";

export const SupplierCreate = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("supplier.create")) return null;

  const transform = async (data: any) => {
    if (data.logo?.rawFile) {
      data.logo = await uploadFile(
        buckets.banners,
        "SupplierLogos",
        nanoid(),
        data.logo.rawFile
      );
    }

    return data;
  };

  return (
    <Create redirect="show" transform={transform}>
      <SupplierForm />
    </Create>
  );
};
